import { useCallback, useState } from 'react'
import { STOCKS_TYPES } from 'src/features/stocks/ducks/consts'
import { EXCHANGE_MAP_TYPES } from 'src/features/stocks/components/map/offerMapUtils'

const toExchangeType = offerType => {
  if (offerType === STOCKS_TYPES.FREE_CARRIERS) {
    return EXCHANGE_MAP_TYPES.FREE_CARRIERS
  }
  if (offerType === STOCKS_TYPES.POST_IMPORT) {
    return EXCHANGE_MAP_TYPES.POST_IMPORT
  }
  return offerType
}

const useActiveDrawerOffer = (exchangeType, exchangeOfferId) => {
  const [drawerOfferType, setDrawerOfferType] = useState(exchangeType)
  const [drawerOffer, setDrawerOffer] = useState(null)

  const selectDrawerOffer = useCallback((offerType, id) => {
    setDrawerOfferType(offerType)
    setDrawerOffer(
      id == null ? null : { offerType: toExchangeType(offerType), id }
    )
  }, [])

  const selectHistoryOffer = useCallback(
    ({ offerType, id }) => selectDrawerOffer(offerType, id),
    [selectDrawerOffer]
  )

  const resetDrawerOffer = useCallback(() => {
    setDrawerOfferType(exchangeType)
    setDrawerOffer(null)
  }, [exchangeType])

  const selectedOfferType = drawerOffer
    ? drawerOffer.offerType
    : toExchangeType(drawerOfferType)
  let selectedOfferId = null
  if (drawerOffer) {
    selectedOfferId = drawerOffer.id
  } else if (selectedOfferType === exchangeType) {
    selectedOfferId = exchangeOfferId
  }

  return {
    drawerOfferType,
    resetDrawerOffer,
    selectDrawerOffer,
    selectHistoryOffer,
    selectedOfferId,
    selectedOfferType
  }
}

export default useActiveDrawerOffer
